module.exports = __webpack_public_path__ + "static/media/loginLogo.4a650672.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/loginLogo.png
// module id = 1017
// module chunks = 0